export const appOperatingSystemMap = {
    android: "android",
    ios: "ios",
} as const;

export type AppOperatingSystem = (typeof appOperatingSystemMap)[keyof typeof appOperatingSystemMap];
